import {
  // eslint-disable-next-line no-restricted-imports
  Link as MuiLink,
  LinkProps,
  ButtonProps,
  Button,
  Typography,
  TypographyTypeMap,
} from "@mui/material";
import _ from "lodash";
import React from "react";
import { ReactElement } from "react";
import {
  // eslint-disable-next-line no-restricted-imports
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from "react-router-dom";

import { palette } from "~frontend/theme";

export const InternalLink = React.forwardRef<any, RouterLinkProps & LinkProps>(
  (props, ref) => <MuiLink {...props} ref={ref} component={RouterLink} />
);

export const ExternalLink = (
  props: Exclude<LinkProps, "to"> & { href: string }
): ReactElement => {
  return <MuiLink target="_blank" rel="noopener noreferrer" {...props} />;
};

export const LinkButton = (
  props: Omit<ButtonProps, "variant"> & {
    variant?: TypographyTypeMap["props"]["variant"];
  }
): ReactElement => {
  return (
    <Button
      {...props}
      sx={{
        p: 0,
        minWidth: "unset",
        color: palette.navy,
        display: "inline-flex",
        verticalAlign: "baseline",
        fontSize: "inherit",
        fontWeight: "inherit",
        lineHeight: "inherit",
        letterSpacing: "inherit",
        fontFamily: "inherit",
        "&:focus,:focus-visible": {
          outline: "none",
          // Puts the focus outline around the span element inside the button
          "& :first-child": {
            outline: `2px solid ${palette.blue}`,
            outlineOffset: "2px",
          },
        },
        "&.Mui-disabled": {
          backgroundColor: palette.white,
        },
        ...props.sx,
      }}
      disableFocusRipple={true}
      variant="link"
    >
      {/* Setting component="span" prevents screen readers from reading the Button as a button group */}
      <Typography variant={props.variant ?? "inherit"} component="span">
        {props.children}
      </Typography>
    </Button>
  );
};

export const ButtonLink = (
  props: { to: string } & ButtonProps
): ReactElement => {
  return <Button {...props} LinkComponent={RouterLink} />;
};
